import * as React from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { Accordion as AccordionPrimitive } from 'radix-ui';
import styles from './accordion.module.css';

import { cn } from '@gokrew/ui/lib/utils';

function Accordion({
  ...props
}: React.ComponentProps<typeof AccordionPrimitive.Root>) {
  return (
    <AccordionPrimitive.Root
      data-slot="accordion"
      className={styles.accordionRoot}
      {...props}
    />
  );
}

function AccordionItem({
  className,
  ...props
}: React.ComponentProps<typeof AccordionPrimitive.Item>) {
  return (
    <AccordionPrimitive.Item
      data-slot="accordion-item"
      className={cn(styles.accordionItem, className)}
      {...props}
    />
  );
}

function AccordionTrigger({
  className,
  iconClassName,
  children,
  ...props
}: React.ComponentProps<typeof AccordionPrimitive.Trigger> & {
  iconClassName?: string;
}) {
  return (
    <AccordionPrimitive.Header className="flex">
      <AccordionPrimitive.Trigger
        data-slot="accordion-trigger"
        className={cn(styles.accordionTrigger, className)}
        {...props}
      >
        {children}
        <ChevronDownIcon className={cn(styles.accordionIcon, iconClassName)} />
      </AccordionPrimitive.Trigger>
    </AccordionPrimitive.Header>
  );
}

function AccordionContent({
  className,
  outerClassName,
  children,
  ...props
}: React.ComponentProps<typeof AccordionPrimitive.Content> & {
  outerClassName?: string;
}) {
  return (
    <AccordionPrimitive.Content
      data-slot="accordion-content"
      className={cn(styles.accordionContent, outerClassName)}
      {...props}
    >
      <div className={cn(styles.accordionContentInner, className)}>
        {children}
      </div>
    </AccordionPrimitive.Content>
  );
}

export { Accordion, AccordionItem, AccordionTrigger, AccordionContent };